export const emptyReq={
    "psid": "",
    "rollNumber": "",
    "businessArea":'',
    "term":'',
    "courseId":[],
    "examCode":[],
    "examDateFrom":"",
    "examDateTo":""
}
